import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [copied, setCopied] = useState(false);
  const serverIP = 'play.furukomc.tr:25633';

  const copyIP = () => {
    navigator.clipboard.writeText(serverIP);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter subscription logic here
    setEmail('');
  };

  return (
    <footer className="relative bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 rounded-t-[3rem] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand & Newsletter */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/c4da685b094ca03001fa4ce318bf4660/f59786c2d124de0541605a3b17561e77.png"
                alt="FurukoNetwork"
                className="w-12 h-12 rounded-full"
              />
              <span className="text-2xl font-bold text-white">FurukoNetwork</span>
            </div>
            <p className="text-white/80 mb-6">
              Özel özellikler ve harika bir toplulukla en iyi Minecraft survival deneyimi.
            </p>

            <h4 className="text-white font-bold mb-3">Güncel Kalın</h4>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-2 bg-white/20 border border-white/30 rounded-full text-white placeholder-white/60 focus:outline-none focus:border-white/50"
                required
              />
              <button
                type="submit"
                className="px-6 py-2 bg-white text-teal-600 rounded-full font-bold hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
              >
                Abone Ol
              </button>
            </form>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Ana Sayfa
                </a>
              </li>
              <li>
                <a href="#about" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Sunucu Hakkında
                </a>
              </li>
              <li>
                <a href="#shop" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Mağaza
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Kurallar
                </a>
              </li>
              <li>
                <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Destek
                </a>
              </li>
            </ul>
          </div>

          {/* Server Info */}
          <div>
            <h4 className="text-white font-bold mb-4">Sunucu Bilgileri</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <i className="ri-server-fill text-white text-xl"></i>
                <div>
                  <p className="text-white/60 text-sm">Sunucu IP</p>
                  <div className="flex items-center gap-2">
                    <p className="text-white font-mono">{serverIP}</p>
                    <button
                      onClick={copyIP}
                      className="w-6 h-6 flex items-center justify-center hover:bg-white/20 rounded cursor-pointer"
                    >
                      <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} text-white text-sm`}></i>
                    </button>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <i className="ri-discord-fill text-white text-xl"></i>
                <div>
                  <p className="text-white/60 text-sm">Discord</p>
                  <a
                    href="https://discord.gg/FurukoNetwork"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white hover:underline cursor-pointer"
                  >
                    discord.gg/FurukoNetwork
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <i className="ri-map-pin-fill text-white text-xl"></i>
                <div>
                  <p className="text-white/60 text-sm">Konum</p>
                  <p className="text-white">Türkiye'de Barındırılıyor</p>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-green-400 rounded-full animate-pulse"></div>
                <p className="text-white">Sunucu Çevrimiçi</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-white text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-white text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-white/30 rounded-full transition-all cursor-pointer"
              >
                <i className="ri-instagram-fill text-white text-lg"></i>
              </a>
            </div>

            <p className="text-white/80 text-center">
              © 2025 FurukoNetwork. Tüm hakları saklıdır.
            </p>

            <div className="flex items-center gap-4">
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                Hizmet Şartları
              </a>
              <span className="text-white/40">•</span>
              <a href="#" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                Gizlilik Politikası
              </a>
            </div>
          </div>
          
          <div className="text-center mt-6">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
